import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { PUBLIC_LEGAL_LINKS } from '../../config/publicLegalLinks';
import { useLanguage } from '../../contexts/LanguageContext';

export default function PublicSiteFooter() {
  const { t } = useLanguage();

  return (
    <footer className="public-site-footer">
      <div className="public-site-container public-site-footer__top">
        <div className="public-site-footer__brand">
          <Link
            to="/"
            className="public-site-brand public-site-brand--footer"
            aria-label="Lmenu"
          >
            <img
              src="/logo.png"
              alt="Lmenu"
              className="public-site-brand__logo public-site-brand__logo--footer"
            />
          </Link>

          <p>{t('landing.footer.description')}</p>
        </div>

        <div className="public-site-footer__trial">
          <strong>{t('landing.freeTrial.footerTitle')}</strong>

          <p>{t('landing.freeTrial.footerDescription')}</p>

          <Link to="/free-trial">
            {t('landing.freeTrial.cta')}
            <ArrowRight size={15} />
          </Link>
        </div>
      </div>

      <div className="public-site-container public-site-footer__bottom">
        <span>{t('landing.footer.copyright')}</span>

        <nav
          className="public-site-footer__legal"
          aria-label={t('legalPages.footerNavigation')}
        >
          {PUBLIC_LEGAL_LINKS.map((page, index) => (
            <span
              key={page.slug}
              className="public-site-footer__legal-item"
            >
              <Link to={page.path}>
                {t(page.labelKey)}
              </Link>

              {index < PUBLIC_LEGAL_LINKS.length - 1 ? (
                <span
                  className="public-site-footer__separator"
                  aria-hidden="true"
                >
                  |
                </span>
              ) : null}
            </span>
          ))}
        </nav>
      </div>
    </footer>
  );
}